import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initDB } from "./utils/offlineDB";

// Register service worker for PWA
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js', {
        scope: '/'
      });
      
      console.log('[App] Service worker registered:', registration.scope);
      
      // Handle updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        console.log('[App] New service worker installing...');
        
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('[App] New version available! Refresh to update.');
          }
        });
      });
      
      // Listen for messages from service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        console.log('[App] Message from SW:', event.data);
        
        if (event.data.type === 'SYNC_OFFLINE_DATA') {
          window.dispatchEvent(new CustomEvent('sync-offline-data'));
        }
      });
      
    } catch (error) {
      console.error('[App] Service worker registration failed:', error);
    }
  }
};

// Initialize offline database
const initializeApp = async () => {
  try {
    await initDB();
    console.log('[App] Offline database initialized');
  } catch (error) {
    console.error('[App] Failed to initialize offline database:', error);
  }
};

// Initialize
initializeApp();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

